const billing = {
  title: 'Billing',

  credit_account: {
    title: 'Credit Account',
    description: 'Used for campaign operation and services',
    top_up: 'Top Up Credit',
    available_balance: 'Available Balance',
    total_funded: 'Total Funded',
    used_this_month: 'Used This Month',
    low_balance_alert: 'Low Balance Alert'
  },

  prize_account: {
    title: 'Prize Security Account',
    description: 'Security funds for weekly & monthly prizes',
    fund: 'Fund Prize Account',
    available_balance: 'Available Balance',
    total_funded: 'Total Funded',
    total_prize_paid: 'Total Prize Paid',
    upcoming_obligation: 'Upcoming Obligation'
  },

  usage_breakdown: {
    title: 'Credit Account Usage Breakdown',
    total_used: 'Total used',
    categories: {
      reward_ads: 'Reward Ads',
      sponsored_quiz: 'Sponsored Quiz',
      sponsored_prediction: 'Sponsored Prediction',
      bonus_coins: 'Bonus Coins',
      setup_service_fee: 'Setup & Service Fee'
    }
  },

  credit_overview: {
    title: 'Credit Account Overview',
    available_balance: 'Available Balance',
    reserved_amount: 'Reserved Amount',
    daily_average_usage: 'Daily Average Usage',
    estimated_days_remaining: 'Estimated Days Remaining',
    auto_top_up: 'Auto Top-up',
    disabled: 'Disabled',
    days: '{{count}} days'
  },

  prize_overview: {
    title: 'Prize Account Overview',
    view_schedule: 'View Prize Schedule',
    secured_prize_balance: 'Secured Prize Balance',
    weekly_prize_reserve: 'Weekly Prize Reserve',
    monthly_prize_reserve: 'Monthly Prize Reserve',
    upcoming_prize_obligations: 'Upcoming prize Obligations',
    next_payout_date: 'Next Payout Date'
  },

  commercial_terms: {
    title: 'Commercial Terms & Rates',
    view_all: 'View All Rates',
    active_terms: 'Active Terms',
    effective_from: 'Effective from {{date}}',
    sales_commission: 'Sales Commission',
    reward_ads: 'Reward Ads',
    sponsored_quiz: 'Sponsored Quiz',
    sponsored_prediction: 'Sponsored Prediction',
    setup_fee: 'Setup Fee'
  },

  summary: {
    title: 'Billing Summary (This Month)',
    net_qualifying_sales: 'Net Qualifying Sales',
    commission_rate: 'Commission Rate',
    quiz_rounds_completed: 'Quiz Rounds Completed',
    prediction_entries: 'Prediction Entries',
    reward_ads_spend: 'Reward Ads Spend',
    total_charges: 'Total Charges'
  },

  recent_transactions: {
    title: 'Recent Transactions',
    view_all: 'View All',
    empty_title: 'No recent transactions',
    empty_hint: 'Transactions will appear here when activity is recorded.',
    columns: {
      date: 'Date',
      account: 'Account',
      description: 'Description',
      type: 'Type',
      amount: 'Amount',
      balance: 'Balance'
    }
  },

  prize_schedule: {
    title: 'Prize Schedule',
    upcoming_prizes: 'Upcoming Prizes',
    funded: 'Funded',
    pending: 'Pending'
  },

  top_up: {
    title: 'Top Up Credit Account',
    banner: 'This top-up funds your Credit Account only. Fund weekly and monthly prizes separately through the Prize Security Account.',

    detail: {
      section_title: 'Payment Detail',
      available_balance: 'Available Balance',
      amount_label: 'Top up Amount',
      minimum: 'Minimum top up: {{amount}}',
      methods_title: 'Select Payment Methods',
      mobile_money: 'Mobile Money',
      mobile_money_desc: 'MTN MoMo • Telecel Cash • AT Money',
      card: 'Card',
      card_desc: 'VISA • Mastercard • Other',
      continue: 'Continue'
    },

    summary: {
      section_title: 'Payment Summary',
      current_balance: 'Current balance',
      top_up_amount: 'Top-up amount',
      processing_fee: 'Processing fee',
      total_to_pay: 'Total to pay',
      expected_balance: 'Expected Balance After Funding',
      payment_method: 'Payment method',
      account: 'Account',
      credit_account: 'Credit Account',
      back: 'Back',
      continue_to_pay: 'Continue To Pay'
    },

    processing: {
      title: 'Redirecting to payment provider…',
      hint: 'Please wait while we securely process your payment.'
    },

    success: {
      title: 'Top Up Successful',
      description: 'Your payment was confirmed and your credit account has been funded',
      amount_credited: 'Amount Credited',
      new_balance: 'New Available Balance',
      section_title: 'Transaction Detail',
      status: 'Status',
      successful: 'Successful',
      payment_method: 'Payment method',
      mobile_number: 'Mobile Number',
      card: 'Card',
      payment_reference: 'Payment Reference',
      date_time: 'Date & Time',
      processing_fee: 'Processing fee',
      total_paid: 'Total paid',
      got_it: 'Got it',
      download_receipt: 'Download Receipt',
      receipt_not_available: 'Receipt download isn\'t available yet. Please contact support for help.'
    },

    failure: {
      title: 'Top Up Failed',
      description: 'We couldn\'t complete your payment. Your Credit Account has not been funded.',
      try_again: 'Try Again',
      cancel: 'Cancel'
    }
  },

  fund_prize: {
    title: 'Fund Prize Security Account',
    banner: 'Prize Security Account funds are reserved for weekly and monthly prizes and cannot be used for campaign operations, Reward Ads, sponsored quizzes, or predictions.',

    detail: {
      section_title: 'Payment Detail',
      available_balance: 'Available Balance',
      upcoming_obligation: 'Upcoming prize obligation',
      next_payout: 'Next payout',
      amount_label: 'Enter Funding Amount',
      minimum: 'Minimum top up: {{amount}}',
      methods_title: 'Select Payment Methods',
      mobile_money: 'Mobile Money',
      mobile_money_desc: 'MTN MoMo • Telecel Cash • AT Money',
      card: 'Card',
      card_desc: 'VISA • Mastercard • Other',
      continue: 'Continue'
    },

    summary: {
      section_title: 'Funding Summary',
      purpose: 'Purpose',
      purpose_value: 'Weekly & monthly prizes',
      current_balance: 'Current Secured Balance',
      funding_amount: 'Funding Amount',
      processing_fee: 'Processing Fee',
      total: 'Total',
      payment_method: 'Payment method',
      account: 'Account',
      prize_account: 'Prize Security Account',
      back: 'Back',
      continue_to_pay: 'Continue To Pay'
    },

    processing: {
      title: 'Redirecting to payment provider…',
      hint: 'Please wait while we securely process your payment.'
    },

    success: {
      title: 'Prize Account funded Successfully',
      description: 'Your payment was confirmed and the funds have been secured for campaign prizes',
      amount_secured: 'Amount Secured',
      new_balance: 'New Available Balance',
      section_title: 'Transaction Detail',
      status: 'Status',
      successful: 'Successful',
      purpose: 'Purpose',
      payment_method: 'Payment method',
      mobile_number: 'Mobile Number',
      card: 'Card',
      payment_reference: 'Payment Reference',
      date_time: 'Date & Time',
      processing_fee: 'Processing fee',
      total_paid: 'Total paid',
      got_it: 'Got it',
      download_receipt: 'Download Receipt',
      receipt_not_available: 'Receipt download isn\'t available yet. Please contact support for help.'
    },

    failure: {
      title: 'Top Up Failed',
      description: 'We couldn\'t complete your payment. Your Prize Security Account has not been funded.',
      try_again: 'Try Again',
      cancel: 'Cancel'
    }
  }
}

export default billing
